<template lang="pug">
b-modal#leaderboardRanking(
  ref="leaderboardRanking"
  :title="$t('ui.leaderboard_ranking')"
  centered
  no-fade
  no-close-on-backdrop
  hide-footer
  :busy="loading"
  size="xl"
  @show="reset"
  @shown="shown")
  b-form(novalidate :disabled="!feedback.success" @submit.stop.prevent="submit")
    .row(v-if="item != null")
      .col-12
        .card.mb-0
          .card-body
            .row
              .col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="9%")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        th.text-center(width="8%")
                          span(:title="$t('ui.ranking')") {{ $t('ui.ranking') }}
                        th(width="10%")
                          span(:title="$t('ui.criteria')") {{ $t('ui.criteria') }}
                        th.text-right(width="10%" v-if="item.criteria == 'TURNOVER'")
                          span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                        th.text-right(width="10%" v-if="item.criteria == 'MULTIPLIER'")
                          span(:title="$t('ui.multiplier')") {{ $t('ui.multiplier') }}
                        th(width="10%")
                          span(:title="$t('ui.reward_type')") {{ $t('ui.reward_type') }}
                        th(width="10%" :class="item.reward_type == 'CREDIT' || item.reward_type == 'INBOX' ? 'text-right' : ''")
                          span(:title="$t('ui.reward')") {{ $t('ui.reward') }}
                        th(width="15%")
                          span(:title="$t('ui.remark')") {{ $t('ui.remark') }}
                        th.text-right(width="12%")
                          span(:title="$t('ui.joined_date')") {{ $t('ui.joined_date') }}
                    tbody.clusterize-content
                      tr(v-if="leaderboardRankingList.length == 0")
                        td(colspan="9").text-center
                          span {{ $t('message.no_data_available') }}
                      tr(v-for="(info, index) in leaderboardRankingList")
                        td.text-center
                          span(:title="index + 1") {{ index + 1 }}
                        td
                          span(:title="info.account_id") {{ info.account_id }}
                        td.text-center
                          span.font-weight-bold(:title="info.ranking") {{ info.ranking }}
                        td
                          span(:title="info.criteria") {{ info.criteria }}
                        td.text-right(v-if="item.criteria == 'TURNOVER'")
                          span.font-weight-bold(v-if="info.turnover != null" :class="$helpers.fontClassName(info.turnover)" :title="$n(info.turnover, 'currency')") {{ $n(info.turnover, 'currency') }}
                          span(v-else) -
                        td.text-right(v-if="item.criteria == 'MULTIPLIER'")
                          span.font-weight-bold(v-if="info.multiplier != null" :class="$helpers.fontClassName(info.multiplier)" :title="$n(info.multiplier, 'currency')") {{ $n(info.multiplier, 'currency') }}
                          span(v-else) -
                        td
                          span(:title="info.reward_type") {{ info.reward_type }}
                        td(:class="item.reward_type == 'CREDIT' || item.reward_type == 'INBOX' ? 'text-right' : ''")
                          template(v-if="info.reward != null")
                            template(v-if="item.reward_type == 'CREDIT' || item.reward_type == 'INBOX'")
                              span.font-weight-bold(:class="$helpers.fontClassName(info.reward)" :title="$n(info.reward, 'currency')") {{ $n(info.reward, 'currency') }}
                            template(v-else)
                              span(:title="info.reward") {{ info.reward }}
                          template(v-else)
                            span -
                        td
                          span(:title="info.remark") {{ info.remark }}
                        td.text-right
                          span(:title="$moment(info.joined_date).format('YYYY-MM-DD, HH:mm:ss')") {{ $moment(info.joined_date).format('YYYY-MM-DD, HH:mm:ss') }}
</template>

<script>
import config from "@/config";

export default {
  components: {},
  props: {
    item: {
      type: Object
    },
    operatorID: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      leaderboardRankingList: [],
      loading: false,
      feedback: {
        success: true,
        status: ""
      }
    };
  },
  computed: {},
  methods: {
    reset() {
      this.feedback.success = true;
      this.feedback.status = "";
    },
    shown() {
      this.leaderboardRankingList = [];
      this.getLeaderboardCampaignRankingList();
    },
    getLeaderboardCampaignRankingList() {
      let url = config.leaderboardCampaignRankingUrl();

      var json = {
        auth_token: this.$store.getters.sessionToken,
        action_by: this.$store.getters.loginId,
        operator_id: this.operatorID,
        leaderboard_campaign_id: this.item.id
      };
      this.loading = true;

      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.leaderboardRankingList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function() {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    }
  }
};
</script>
